/** Статус модуля. */
export enum ModuleStatus {
    /** Скрытый. */
    Hidden = "hidden",

    /** Опубликованный. */
    Published = "published",
}
